// ** React Import
import { useState } from 'react';

// ** Custom Components
import Sidebar from '@components/sidebar';
import Avatar from '@components/avatar';
import { ListUserCredits } from '../../../../graphql/Query';
import { ClaimedCredit } from '../../../../graphql/Mutation';
import { Input } from 'reactstrap';
import {
    useQuery,
    useMutation
} from '@apollo/client';

const activityes = [
    {
        label: 'Completar episodios',
        value: 'EPOSODES'
    },
    {
        label: 'Completar caminos',
        value: 'ROADS'
    },
    {
        label: 'Completar activityes',
        value: 'ACTIVITIES'
    },
    {
        label: 'Racha de días en la app',
        value: 'ACTIVITIES'
    },
    {
        label: 'Racha de días en la app',
        value: 'APP_STREAK'
    },
    {
        label: 'Racha de días premium',
        value: 'PREMIUM_STREAK'
    },
    {
        label: 'Invitación a un plan',
        value: 'PLAN_INTITATION'
    },
    {
        label: 'Invitación de amigos',
        value: 'FRIEND_INVITATION'
    }
];

const Item = ({ data, refetch }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [mutate] = useMutation(ClaimedCredit);

    // Simulando la función de mutación comentada
    const changeData = async () => {
        try {

            await mutate({
                variables: {
                    claimedCreditId: data._id
                }
            });
            refetch();
            // Aquí puedes realizar alguna lógica o mutación
            console.log(`Cambiando estado del item con ID: ${data._id}`);
            // mutate({ id: data._id, claimed: !isChecked });
        } catch (error) {
            console.error('Error al cambiar el estado:', error);
        }
    };

    // Manejar el cambio del checkbox
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        changeData();
    };

    return (
        <div className="row mb-1 mt-1">
            <div className="col-2">
                <Avatar
                    initials
                    color={'light-primary'}
                    content={data.user.fullName || ''}
                />
            </div>
            <div className="col p-0">{data.user.fullName}</div>
            <div className="col-2 p-0">
                {
                    data.completed ? (
                        <Input
                            type="checkbox"
                            id={data._id}
                            checked={true}
                        />) : (
                        <Input
                            type="checkbox"
                            id={data._id}
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                    )
                }
            </div>
        </div>
    );
};

const SidebarEarnCredit = ({
    open,
    toggleSidebar,
    Credit
}) => {
    console.log('Credit', Credit);

    const { data, loading,
        refetch
    } = useQuery(ListUserCredits, {
        variables: {
            input: {
                creditSettingId: Credit._id,
                page: 1,
                perPage: 20
            }
        },
        skip: !Credit,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-first'
    });

    const users = data?.listUserCredits?.docs || [];

    const getUser = () => {
        return users.map((e) => {
            return (<Item data={e} refetch={refetch} />);
        });
    };

    return (
        <Sidebar
            size="lg"
            open={open}
            title={''}
            headerClassName="mb-1"
            contentClassName="pt-0"
            toggleSidebar={toggleSidebar}
            onClosed={toggleSidebar}
        >
            <div>
                <div style={{ textAlign: 'left', font: 'normal normal 600 22px/33px Geist', letterSpacing: '0px', color: '#000000' }}>
                    <div style={{ fontWeight: 'bold' }}>Actividad</div> {activityes.find(e => e.value === Credit.activity)?.label}
                </div>
                <div style={{ textAlign: 'left', font: 'normal normal normal 14px/21px Geist', letterSpacing: '0px', color: '#000000' }}>
                    Lista de personas que se han ganado el beneficio. Marca con un check los beneficios externos que hayas atendido.
                </div>
            </div>
            <div>
                {
                    !loading && getUser()
                }
            </div>
        </Sidebar>
    );
};

export default SidebarEarnCredit;
